import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Categories from "../pages/categories/page";
import ArticleList from "../pages/articles/page";
import ArticleDetail from "../pages/articles/detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/categories",
    element: <Categories />,
  },
  {
    path: "/articles",
    element: <ArticleList />,
  },
  {
    path: "/articles/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;